function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_895",
  "data-name": "Rectangle 895",
  width: 24,
  height: 24,
  rx: 12,
  fill: "#ccc"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_3780",
  "data-name": "Path 3780",
  d: "M8.064,1A.916.916,0,0,0,8.555.868,1.065,1.065,0,0,0,8.906.52.859.859,0,0,0,9.038.059V-4.307h4.27a.909.909,0,0,0,.476-.132.98.98,0,0,0,.348-.352.956.956,0,0,0,.128-.491.942.942,0,0,0-.128-.483.98.98,0,0,0-.348-.352.909.909,0,0,0-.476-.132H9.038v-4.365a.89.89,0,0,0-.132-.472,1.02,1.02,0,0,0-.352-.348.935.935,0,0,0-.491-.132.922.922,0,0,0-.483.132,1.02,1.02,0,0,0-.352.348.89.89,0,0,0-.132.472v4.365H2.827a.9.9,0,0,0-.469.132A1.041,1.041,0,0,0,2-5.764a.9.9,0,0,0-.135.483A.916.916,0,0,0,2-4.79a1.041,1.041,0,0,0,.355.352.9.9,0,0,0,.469.132H7.1V.059A.859.859,0,0,0,7.229.52a1.065,1.065,0,0,0,.352.348A.9.9,0,0,0,8.064,1Z",
  transform: "translate(4 17)"
});

function SvgIcNewArea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2181",
    "data-name": "Group 2181",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNewArea);
export default ForwardRef;